module.exports = __webpack_public_path__ + "static/media/collapse.72535201.jpg";